import PlainInput from './PlainInput';

export default PlainInput;
